<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>管理员管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.nickname" placeholder="输入用户"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.phone" placeholder="输入电话"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
              element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="60"></el-table-column>
      <el-table-column sortable prop="id" label="ID" width="60" show-overflow-tooltip></el-table-column>
      <el-table-column prop="nickname" label="用户" show-overflow-tooltip></el-table-column>
      <el-table-column prop="phone" label="电话" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="is_lock" label="是否锁定" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ scope.row.is_lock == 1 ? '是' : '否' }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="add_time" label="创建时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="getOperators(scope.row)">查看操作员</el-button>
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 操作员界面 -->
    <el-dialog :title="title" :visible.sync="operatorVisible" width="50%" @click="closeOperator()">
      <el-table size="small" :data="listOperatorData" highlight-current-row v-loading="loading" border
                element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" label="序号" type="index" width="60"></el-table-column>
        <el-table-column prop="nickname" label="用户昵称"></el-table-column>
        <el-table-column prop="phone" label="电话"></el-table-column>
        <el-table-column prop="add_time" label="创建时间">
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('editForm')">
      <el-form label-width="120px" :model="editForm" ref="editForm">
        <el-row>
          <el-col :span="24">
            <el-form-item label="用户">
              <el-input size="small" v-model="editForm.nickname" auto-complete="off"
                        placeholder="请输入用户名称"></el-input>
            </el-form-item>
            <el-form-item label="电话">
              <el-input size="small" v-model="editForm.phone" auto-complete="off"
                        placeholder="请输入电话"></el-input>
            </el-form-item>
            <el-form-item label="是否锁定">
              <el-switch v-model="editForm.is_lock" active-color="#13ce66" inactive-color="#ff4949">
              </el-switch>
            </el-form-item>

            <el-form-item>
              <div class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title"
                           @click="submitForm('editForm')">保存
                </el-button>
              </div>
            </el-form-item>

          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import {searchOperator, wechatManager, wechatSaveManager, wechatDeleteManager} from "../../api/userMG";

export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      operatorVisible: false, //控制操作员页面显示与隐藏
      title: '添加/修改管理员',
      editForm: {
        id: null,
        is_lock: 0,
        nickname: '',
        phone: '',
      },
      formInline: {
        page: 1,
        limit: 10,
        pageSize: 10,
        nickname: '',
        phone: '',
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      listOperatorData: [], //操作员数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getdata(parameter) {
      this.loading = true
      // 模拟数据开始
      wechatManager(parameter).then(res => {
        this.listData = res.items
        this.loading = false
        this.pageparm.currentPage = this.formInline.page
        this.pageparm.pageSize = this.formInline.limit
        this.pageparm.total = res.pageInfo.total
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示操作员界面
    getOperators: function (row) {
      this.operatorVisible = true
      searchOperator({id: row.id}).then(res => {
        this.listOperatorData = res.data
      })
    },
    //显示编辑界面
    handleEdit: function (row) {
      this.editFormVisible = true
      this.editForm = row
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          let row = this.editForm
          let params = {id: row.id, nickname: row.nickname, phone: row.phone, is_lock: row.is_lock}
          wechatSaveManager(params)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: '保存失败！'
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('管理员保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除管理员
    deleteUser(row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        wechatDeleteManager({id: [row.id]})
          .then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '管理员已删除!'
              })
              this.getdata(this.formInline)
            } else {
              this.$message({
                type: 'info',
                message: '管理员删除失败!'
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('管理员删除失败，请稍后再试！')
          })
      })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeOperator() {
      this.operatorVisible = false
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>







// WEBPACK FOOTER //
// src/views/wechatManager/wechatManager.vue